(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-list-slider')) {
    class CollectionListSlider extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        requestAnimationFrame(() => {
          this.track = this.querySelector('.collection-list-slider__track');
          this.prevBtn = this.querySelector('.prev');
          this.nextBtn = this.querySelector('.next');
          this.init();
          this.initResizeObserver();
        });
      }

      init() {
        if (!this.track) return;

        // Arrow controls
        if (this.prevBtn && this.nextBtn) {
          const scrollAmount = () => {
            const slide = this.track.querySelector('.collection-list-slider__slide');
            const slideCount = parseInt(this.track.dataset.slideCount, 10) || 1;
            if (!slide) return this.track.clientWidth * 0.8;
            const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
            return (slide.getBoundingClientRect().width + gap) * slideCount;
          };

          this.prevBtn.addEventListener('click', () => {
            this.track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
          });

          this.nextBtn.addEventListener('click', () => {
            this.track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
          });
        }

        this.track.addEventListener('dragstart', (e) => e.preventDefault());

        let isDown = false;
        let moved = false;
        let startX = 0;
        let startScrollLeft = 0;
        let lastX = 0;
        let lastT = 0;
        let velocity = 0;
        let momentumId = null;

        const cancelMomentum = () => {
          if (momentumId) {
            cancelAnimationFrame(momentumId);
            momentumId = null;
          }
        };

        this.track.addEventListener('pointerdown', (e) => {
          // HYBRID FIX: Ignore touch completely, let native CSS scrolling handle mobile perfectly.
          if (e.pointerType === 'touch') return; 
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          
          cancelMomentum();
          isDown = true;
          moved = !!momentumId; 
          startX = e.clientX;
          lastX = e.clientX;
          startScrollLeft = this.track.scrollLeft;
          lastT = performance.now();
          velocity = 0;
        });

        this.track.addEventListener('pointermove', (e) => {
          if (!isDown) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 3) {
            moved = true;
            this.track.classList.add('is-dragging');
          }
          if (!moved) return;
          this.track.scrollLeft = startScrollLeft - dx;

          const now = performance.now();
          const dt = now - lastT;
          if (dt > 0) velocity = (e.clientX - lastX) / dt;
          lastX = e.clientX;
          lastT = now;
        });

        const endDrag = (e) => {
          if (!isDown) return;
          isDown = false;
          this.track.classList.remove('is-dragging');

          let v = velocity * 16;
          const friction = 0.94;
          const step = () => {
            if (Math.abs(v) < 0.5) {
              momentumId = null;
              return;
            }
            this.track.scrollLeft -= v;
            v *= friction;
            momentumId = requestAnimationFrame(step);
          };
          if (Math.abs(v) > 1) momentumId = requestAnimationFrame(step);
        };

        this.track.addEventListener('pointerup', endDrag);
        this.track.addEventListener('pointercancel', endDrag);
        this.track.addEventListener('pointerleave', (e) => {
          if (isDown && !moved) endDrag(e);
        });

        this.track.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            setTimeout(() => { moved = false; }, 50);
          }
        }, true);

        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        setTimeout(() => this.updateButtons(), 100);
      }

      initResizeObserver() {
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateButtons() {
        if (!this.track) return;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
        if (this.nextBtn) {
          const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
          this.nextBtn.disabled = isAtEnd;
        }
      }
    }
    customElements.define('collection-list-slider', CollectionListSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-slider')) {
    class CollectionSlider extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;

        requestAnimationFrame(() => {
          this.track = this.querySelector('.tabbed-slider-track');
          if (!this.track) return;

          this._initialized = true;
          this.initSlider();
        });
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        this._initialized = false;
      }

      initSlider() {
        const track = this.track;
        const prevBtn = this.querySelector('.prev');
        const nextBtn = this.querySelector('.next');

        this._resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target.offsetWidth > 0) {
              this.updateSliderButtons(entry.target);
            }
          });
        });

        if (prevBtn && nextBtn) {
          const getScrollAmount = () => {
            const slide = track.querySelector('.tabbed-slider-slide');
            const slideCount = parseInt(track.dataset.slideCount, 10) || 1;
            const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;

            const slideWidth = (slide && slide.offsetWidth > 0)
              ? slide.getBoundingClientRect().width
              : (track.clientWidth / (parseInt(getComputedStyle(this).getPropertyValue('--tc-items-desktop'), 10) || 4));

            return (slideWidth + gap) * slideCount;
          };

          prevBtn.addEventListener('click', () => {
            track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
          });

          nextBtn.addEventListener('click', () => {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          });
        }

        track.addEventListener('dragstart', (e) => e.preventDefault());

        this.attachSmoothDrag(track);
        track.addEventListener('scroll', () => this.updateSliderButtons(track), { passive: true });
        this._resizeObserver.observe(track);

        requestAnimationFrame(() => this.updateSliderButtons(track));
      }

      attachSmoothDrag(track) {
        let isDown = false;
        let moved = false;
        let startX = 0;
        let startScrollLeft = 0;
        let lastX = 0;
        let lastT = 0;
        let velocity = 0;
        let momentumId = null;

        const cancelMomentum = () => {
          if (momentumId) {
            cancelAnimationFrame(momentumId);
            momentumId = null;
          }
        };

        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'touch') return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;

          cancelMomentum();
          isDown = true;
          moved = false;
          startX = e.clientX;
          lastX = e.clientX;
          startScrollLeft = track.scrollLeft;
          lastT = performance.now();
          velocity = 0;
        });

        track.addEventListener('pointermove', (e) => {
          if (!isDown || e.pointerType === 'touch') return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 3) {
            moved = true;
            track.classList.add('is-dragging');
            try {
              track.setPointerCapture(e.pointerId);
            } catch (err) {}
          }
          if (!moved) return;
          track.scrollLeft = startScrollLeft - dx;

          const now = performance.now();
          const dt = now - lastT;
          if (dt > 0) velocity = (e.clientX - lastX) / dt;
          lastX = e.clientX;
          lastT = now;
        });

        const endDrag = (e) => {
          if (!isDown || e.pointerType === 'touch') return;
          isDown = false;
          track.classList.remove('is-dragging');
          if (moved) {
            try {
              track.releasePointerCapture(e.pointerId);
            } catch (err) {}
          }

          let v = velocity * 16;
          const friction = 0.94;
          const step = () => {
            if (Math.abs(v) < 0.5) {
              momentumId = null;
              return;
            }
            track.scrollLeft -= v;
            v *= friction;
            momentumId = requestAnimationFrame(step);
          };
          if (Math.abs(v) > 1) momentumId = requestAnimationFrame(step);
        };

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        track.addEventListener(
          'click',
          (e) => {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
      }

      updateSliderButtons(track) {
        if (!track || track.offsetWidth === 0) return;

        const wrapper = track.parentElement;
        if (!wrapper) return;

        const prevBtn = wrapper.querySelector('.prev');
        const nextBtn = wrapper.querySelector('.next');

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if (nextBtn) {
          const isAtEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2;
          nextBtn.disabled = isAtEnd;
        }
      }
    }
    customElements.define('collection-slider', CollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('infinite-carousel')) {
    class InfiniteCarousel extends HTMLElement {
      connectedCallback() {
        // Guard against connectedCallback firing more than once. Set
        // synchronously, before scheduling the rAF below - see
        // tabbed-collection.liquid for why setting it late creates a
        // re-entrancy race that double-initializes the carousel.
        if (this._initialized) return;
        this._initialized = true;

        // IMPORTANT: do not read children in the constructor. Per the Custom
        // Elements spec, a constructor must not inspect attributes or children -
        // the DOM subtree isn't guaranteed to exist yet. In practice this only
        // bites when the same section is used more than once on a page: the
        // browser upgrades every <infinite-carousel> the moment it sees the
        // opening tag, before that instance's own children have been parsed.
        // Reading this.querySelector('.custom-carousel-track') in the
        // constructor returned null for every instance after the first, and
        // this.track.children then threw - breaking the whole script (and
        // with it every other slider on the page). Deferring by one frame
        // guarantees the full subtree exists first, for every instance.
        requestAnimationFrame(() => {
          this.track = this.querySelector('.custom-carousel-track');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.prevBtn = this.querySelector('.prev');
          this.nextBtn = this.querySelector('.next');

          this.isAnimating = false;
          this.autoplayInterval = null;
          this.speed = parseInt(this.dataset.speed) || 3000;

          this.init();
        });
      }

      disconnectedCallback() {
        this.pause();
      }

      init() {
        if (this.slides.length <= 1) {
          this.prevBtn.style.display = 'none';
          this.nextBtn.style.display = 'none';
          return;
        }

        this.prevBtn.addEventListener('click', () => this.move('prev'));
        this.nextBtn.addEventListener('click', () => this.move('next'));

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());

        this.addEventListener('touchstart', () => this.pause(), { passive: true });
        this.addEventListener('touchend', () => this.play(), { passive: true });

        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());

        this.play();
      }

      getSlideWidth() {
        return this.slides[0].offsetWidth;
      }

      move(direction) {
        if (this.isAnimating) return;
        this.isAnimating = true;

        const slideWidth = this.getSlideWidth();
        this.track.style.transition = 'transform 0.5s ease-in-out';

        if (direction === 'next') {
          this.track.style.transform = `translateX(-${slideWidth}px)`;
          setTimeout(() => {
            this.track.style.transition = 'none';
            this.track.appendChild(this.track.firstElementChild);
            this.track.style.transform = 'translateX(0)';
            this.isAnimating = false;
          }, 500);
        } else {
          this.track.style.transition = 'none';
          this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
          this.track.style.transform = `translateX(-${slideWidth}px)`;
          
          void this.track.offsetWidth;
          
          this.track.style.transition = 'transform 0.5s ease-in-out';
          this.track.style.transform = 'translateX(0)';
          setTimeout(() => {
            this.isAnimating = false;
          }, 500);
        }
      }

      play() {
        this.pause();
        if (this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.autoplayInterval = setInterval(() => this.move('next'), this.speed);
      }

      pause() {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
    customElements.define('infinite-carousel', InfiniteCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-reels-slider')) {
    class ShoppableReelsSlider extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        requestAnimationFrame(() => {
          this.track = this.querySelector('.reels-slider__track');
          this.prevBtn = this.querySelector('.prev');
          this.nextBtn = this.querySelector('.next');
          this.initSlider();
          this.initResizeObserver();
        });
      }

      initSlider() {
        if (!this.track) return;

        if (this.prevBtn && this.nextBtn) {
          const scrollAmount = () => this.track.clientWidth * 0.8;
          this.prevBtn.addEventListener('click', () => this.track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
          this.nextBtn.addEventListener('click', () => this.track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
        }

        this.track.addEventListener('dragstart', (e) => e.preventDefault());

        let isDown = false;
        let moved = false;
        let startX = 0;
        let startScrollLeft = 0;
        let lastX = 0;
        let lastT = 0;
        let velocity = 0;
        let momentumId = null;

        const cancelMomentum = () => {
          if (momentumId) {
            cancelAnimationFrame(momentumId);
            momentumId = null;
          }
        };

        this.track.addEventListener('pointerdown', (e) => {
          // HYBRID FIX: Ignore touch completely, let native CSS scrolling handle mobile perfectly.
          if (e.pointerType === 'touch') return; 
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          
          cancelMomentum();
          isDown = true;
          moved = !!momentumId; 
          startX = e.clientX;
          lastX = e.clientX;
          startScrollLeft = this.track.scrollLeft;
          lastT = performance.now();
          velocity = 0;
        });

        this.track.addEventListener('pointermove', (e) => {
          if (!isDown) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 3) {
            moved = true;
            this.track.classList.add('is-dragging');
          }
          if (!moved) return;
          this.track.scrollLeft = startScrollLeft - dx;

          const now = performance.now();
          const dt = now - lastT;
          if (dt > 0) velocity = (e.clientX - lastX) / dt;
          lastX = e.clientX;
          lastT = now;
        });

        const endDrag = (e) => {
          if (!isDown) return;
          isDown = false;
          this.track.classList.remove('is-dragging');

          let v = velocity * 16;
          const friction = 0.94;
          const step = () => {
            if (Math.abs(v) < 0.5) {
              momentumId = null;
              return;
            }
            this.track.scrollLeft -= v;
            v *= friction;
            momentumId = requestAnimationFrame(step);
          };
          if (Math.abs(v) > 1) momentumId = requestAnimationFrame(step);
        };

        this.track.addEventListener('pointerup', endDrag);
        this.track.addEventListener('pointercancel', endDrag);
        this.track.addEventListener('pointerleave', (e) => {
          if (isDown && !moved) endDrag(e);
        });

        this.track.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            setTimeout(() => { moved = false; }, 50);
          }
        }, true);

        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.updateButtons();
      }

      initResizeObserver() {
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateButtons() {
        if (!this.track) return;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
        if (this.nextBtn) {
          const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
          this.nextBtn.disabled = isAtEnd;
        }
      }
    }
    customElements.define('shoppable-reels-slider', ShoppableReelsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-collection')) {
    class TabbedCollection extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        
        requestAnimationFrame(() => {
          this.tabs = this.querySelectorAll('.tabbed-collection__tab-btn');
          this.panels = this.querySelectorAll('.tabbed-collection__panel');
          
          if (!this.tabs.length || !this.panels.length) return;

          this._initialized = true;
          this.normalizeActiveState();
          this.bindEvents();
          this.initSliders();
        });
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        this._initialized = false;
      }

      normalizeActiveState() {
        let activeIndex = Array.from(this.tabs).findIndex(
          (t) => t.getAttribute('aria-selected') === 'true'
        );
        if (activeIndex === -1) activeIndex = 0;

        this.tabs.forEach((t, i) => {
          t.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        });
        this.panels.forEach((p, i) => {
          p.classList.toggle('is-active', i === activeIndex);
        });
      }

      bindEvents() {
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
            tab.setAttribute('aria-selected', 'true');

            this.panels.forEach((p) => p.classList.remove('is-active'));
            const targetPanel = this.panels[index];
            if (targetPanel) {
              targetPanel.classList.add('is-active');

              requestAnimationFrame(() => {
                const track = targetPanel.querySelector('.tabbed-slider-track');
                if (track) this.updateSliderButtons(track);
              });
            }
          });
        });
      }

      initSliders() {
        this._resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target.offsetWidth > 0) {
              this.updateSliderButtons(entry.target);
            }
          });
        });

        this.panels.forEach((panel) => {
          const track = panel.querySelector('.tabbed-slider-track');
          const prevBtn = panel.querySelector('.prev');
          const nextBtn = panel.querySelector('.next');

          if (!track) return;

          if (prevBtn && nextBtn) {
            const getScrollAmount = () => {
              const slide = track.querySelector('.tabbed-slider-slide');
              const slideCount = parseInt(track.dataset.slideCount, 10) || 1;
              const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
              
              const slideWidth = (slide && slide.offsetWidth > 0) 
                ? slide.getBoundingClientRect().width 
                : (track.clientWidth / (parseInt(track.style.getPropertyValue('--tc-items-desktop')) || 4));

              return (slideWidth + gap) * slideCount;
            };

            prevBtn.addEventListener('click', () => {
              track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', () => {
              track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            });
          }

          this.attachSmoothDrag(track);
          track.addEventListener('scroll', () => this.updateSliderButtons(track), { passive: true });
          this._resizeObserver.observe(track);

          if (panel.classList.contains('is-active')) {
            requestAnimationFrame(() => this.updateSliderButtons(track));
          }
        });
      }

      attachSmoothDrag(track) {
  let isDown = false;
  let moved = false;
  let startX = 0;
  let startScrollLeft = 0;
  let lastX = 0;
  let lastT = 0;
  let velocity = 0;
  let momentumId = null;

  const cancelMomentum = () => {
    if (momentumId) {
      cancelAnimationFrame(momentumId);
      momentumId = null;
    }
  };

  track.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'touch') return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    cancelMomentum();
    isDown = true;
    moved = false;
    startX = e.clientX;
    lastX = e.clientX;
    startScrollLeft = track.scrollLeft;
    lastT = performance.now();
    velocity = 0;
  });

  track.addEventListener('pointermove', (e) => {
    if (!isDown || e.pointerType === 'touch') return;
    const dx = e.clientX - startX;
    if (!moved && Math.abs(dx) > 3) {
      moved = true;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    }
    if (!moved) return;
    track.scrollLeft = startScrollLeft - dx;

    const now = performance.now();
    const dt = now - lastT;
    if (dt > 0) velocity = (e.clientX - lastX) / dt;
    lastX = e.clientX;
    lastT = now;
  });

  const endDrag = (e) => {
    if (!isDown || e.pointerType === 'touch') return;
    isDown = false;
    track.classList.remove('is-dragging');
    if (moved) {
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    let v = velocity * 16;
    const friction = 0.94;
    const step = () => {
      if (Math.abs(v) < 0.5) {
        momentumId = null;
        return;
      }
      track.scrollLeft -= v;
      v *= friction;
      momentumId = requestAnimationFrame(step);
    };
    if (Math.abs(v) > 1) momentumId = requestAnimationFrame(step);
  };

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  track.addEventListener(
    'click',
    (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
}

      updateSliderButtons(track) {
        if (!track || track.offsetWidth === 0) return;
        
        const wrapper = track.parentElement;
        if (!wrapper) return;
        
        const prevBtn = wrapper.querySelector('.prev');
        const nextBtn = wrapper.querySelector('.next');

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if (nextBtn) {
          const isAtEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2;
          nextBtn.disabled = isAtEnd;
        }
      }
    }
    customElements.define('tabbed-collection', TabbedCollection);
  }

  } catch(e) { console.error(e); }
})();
})();
